import React, { useContext } from 'react';
import { Box, Alert } from '@mui/material';
import GreetingCard from './GreetingCard';
import StatsGrid from './StatsGrid';
import ChartSection from './ChartSection';
import TopMembers from './Topmembers';
import MemberLocationsCard from './MemberLocationsCard';
import useDashboardData from './useDashboardData';
import { ModulesContext, isModuleActive } from '../../utils/ModulesContext';

// Map chart IDs to module IDs
const CHART_MODULE = { violations: 2, maintenance: 1, overview: 1, architectural: 3 };

const Dashboard = () => {
  const { modules } = useContext(ModulesContext);
  const {
    userFullName,
    currentTime,
    stats,
    violationsByYearChart,
    maintenanceByMonth,
    workOrderChartData,
    architecturalRequestsByYearChart,
    error,
  } = useDashboardData();

  // Filter stat cards and charts by active modules
  const filteredStats = stats.filter(
    (s) => !s.moduleId || isModuleActive(modules, s.moduleId)
  );
  const activeCharts = ['violations', 'maintenance', 'overview', 'architectural'].filter(
    (id) => isModuleActive(modules, CHART_MODULE[id])
  );

  return (
    <Box sx={{ padding: 3 }}>
      {error && <Alert severity="error" sx={{ mb: 2, borderRadius: "12px" }}>{error}</Alert>}
      <GreetingCard userFullName={userFullName} currentTime={currentTime} />
      <StatsGrid stats={filteredStats} />

      <ChartSection
        columns={3}
        visibleCharts={activeCharts}
        violationsByMonth={violationsByYearChart}
        maintenanceByMonth={maintenanceByMonth}
        workOrderChartData={workOrderChartData}
        architecturalByMonth={architecturalRequestsByYearChart}
      />

      <Box sx={{ marginTop: 5 }}>
        <TopMembers />
      </Box>
      <MemberLocationsCard />
    </Box>
  );
};

export default Dashboard;
